import { happyHourEndpoints } from "./hh.api.ts"

export const {
  useGetHappyHourQuery,
  endpoints: { getHappyHour }
} = happyHourEndpoints

export { default as happyHourSelectors } from "./hh.selectors"
